export default "__VITE_ASSET__4ef3d41f__"